<template>
    <div class="text-center">
        <b-spinner style="width: 3rem; height: 3rem;"></b-spinner>
        <hr />
        <strong>{{ value }}</strong>
    </div>
</template>

<script>
    export default {
        props: ['text'],
        data() {
            return {
                value: this.text,
                time: Date.now(),
                interval: null
            }
        },
        created() {
            this.interval = setInterval(() => {
                this.value += '.'
                if (Date.now() - this.time > 5000) {
                    this.time = Date.now()
                    this.$bvToast.toast('Still trying. Please wait.', {
                        title: this.text + '...',
                        variant: 'info'
                    })
                }
            }, 100)
        },
        beforeDestroy() {
            clearInterval(this.interval)
        }
    }
</script>